export interface ProcessedImageSelectionState {
  selectedProcessedIndex: number | undefined
  originalIsActive: boolean
}

export const getProcessedImageSelectionState = (
  tabValue: string,
  processedImageCount: number,
  selectedProcessedIndexByTab: Record<string, number>,
): ProcessedImageSelectionState => {
  if (processedImageCount === 0) {
    return {
      selectedProcessedIndex: undefined,
      originalIsActive: true,
    }
  }

  const storedSelection = selectedProcessedIndexByTab[tabValue]

  if (storedSelection === -1) {
    return {
      selectedProcessedIndex: undefined,
      originalIsActive: true,
    }
  }

  if (typeof storedSelection === 'number') {
    const normalizedIndex = Math.min(Math.max(storedSelection, 0), processedImageCount - 1)
    return {
      selectedProcessedIndex: normalizedIndex,
      originalIsActive: false,
    }
  }

  return {
    selectedProcessedIndex: 0,
    originalIsActive: false,
  }
}
